<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/store/user/userStore'
import { useDate, useDisplay } from 'vuetify'
import PractitionerAvatar from '@/components/PractitionerAvatar.vue'
const { mdAndDown, xs, sm, smAndDown, mdAndUp } = useDisplay()

const $t = useI18n().t
const { smAndUp, mobile } = useDisplay()
const userStore = useUserStore()
const date = useDate()

const currentDate = ref('')

const updateDate = () => {
  const now = new Date()
  const dateString = date.format(now, 'fullDateWithWeekday')
  currentDate.value = dateString.charAt(0).toUpperCase() + dateString.slice(1)
}

const mainDiscipline = computed(() => {
  return userStore.user.mainDiscipline
})

const welcomeText = computed(() => {
  return userStore.isLogged &&
    userStore.user?.firstName &&
    userStore.user?.lastName
    ? userStore.user?.firstName + ' ' + userStore.user?.lastName['0'] + '.'
    : $t('appBar.welcome')
})

onMounted(() => {
  updateDate()
  const interval = setInterval(updateDate, 60000)
  onUnmounted(() => {
    clearInterval(interval)
  })
})
</script>

<template>
  <v-menu offset-y>
    <template v-slot:activator="{ props }">
      <v-list bg-color="transparent" rounded>
        <v-list-item
          rounded
          v-bind="props"
          :prepend-avatar="userStore.user?.avatar?.url"
          :slim="mobile"
        >
          <template #title v-if="!smAndDown">
            <span
              class="font-weight-medium"
              style="color: #007058; font-size: 13px"
              >{{ welcomeText }}</span
            >
          </template>
          <template #subtitle v-if="!smAndDown">
            <span v-if="mainDiscipline">
              {{ mainDiscipline }}
            </span>
            <span
              v-else
              class="font-bold"
              style="color: #9e9e9e; font-size: 13px"
              >{{ mobile ? undefined : currentDate }}</span
            >
          </template>

          <template #prepend v-if="!userStore.user?.avatar?.url">
            <component
              class="mr-2 border rounded-pill"
              :is="PractitionerAvatar"
              size="43px"
              color="#9E9E9E"
            />
          </template>
        </v-list-item>
      </v-list>
    </template>

    <v-list
      bg-color="white"
      base-color="#757575"
      rounded="lg"
      class="mt-2 pa-2"
      density="compact"
      nav
    >
      <v-list-item :to="{ name: 'DashboardHome' }" active-class="active-menu">
        <v-list-item-title class="d-flex align-center ga-1">
          <v-icon>mdi-view-dashboard</v-icon>
          <span>{{ $t('appBar.dashboard') }}</span>
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="() => userStore.logout()">
        <v-list-item-title class="d-flex align-center ga-1">
          <span style="color: #757575">
            <v-icon>mdi-logout</v-icon>
            <span>{{ $t('appBar.logout') }}</span>
          </span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped lang="scss">
.active-menu {
  background-color: rgba(2, 153, 120, 0.1);
}
</style>
